import React, { useState, useEffect } from 'react';
import { Button, Paper, Typography, TextField, FormControl, Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { createStock, updateStock } from '../../redux/actions/stock/stockAction';
import { toast } from 'react-toastify';

const StockForm = ({ selectedStock, onReset }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: '',
  });

  useEffect(() => {
    if (selectedStock) {
      setFormData(selectedStock);
    } else {
      setFormData({ name: '' });
    }
  }, [selectedStock]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (selectedStock) {
        await dispatch(updateStock(selectedStock.id, formData));
        toast.success('Stock updated successfully');
      } else {
        await dispatch(createStock(formData));
        toast.success('Stock created successfully');
      }
      setFormData({ name: '' });
      if (onReset) onReset();
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message || 'An error occurred while processing stock';
      toast.error(errorMessage);
    }
  };

  const handleClear = () => {
    setFormData({ name: '' });
    if (onReset) onReset();
  };

  return (
    <Paper elevation={3} sx={{ p: 3, boxShadow: 'none', background: 'transparent' }}>
      <Typography variant="h6" sx={{ fontWeight: 'bold' }} gutterBottom>
        {selectedStock ? 'Edit Stock Type' : 'Add Stock Type'}
      </Typography>
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth margin="normal" required>
          <TextField
            name="name"
            value={formData.name}
            label="Stock Type"
            onChange={handleChange}
            fullWidth
          />
        </FormControl>
        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
          <Button type="submit" variant="contained" color="primary" fullWidth>
            {selectedStock ? 'Update' : 'Add'}
          </Button>
          <Button 
            type="button" 
            variant="outlined" 
            color="primary" 
            fullWidth
            onClick={handleClear}
          >
            Clear
          </Button>
        </Box>
      </form>
    </Paper>
  );
};

export default StockForm;
